import { render, staticRenderFns } from "./foodDetail.vue?vue&type=template&id=3ffd0282"
import script from "./foodDetail.vue?vue&type=script&lang=js"
export * from "./foodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports